<template>
  <v-dialog
    :value="value"
    @change="$emit('input', $event)"
    persistent
    width="400px"
  >
    <v-card>
      <v-card-title class="headline">Imprimir</v-card-title>
      <v-card-text>{{ message }}</v-card-text>

      <v-card-text>
        <ValidationObserver ref="print_form">
          <ValidationProvider
            rules="required"
            name="copies"
            v-slot="{ errors }"
          >
            <v-text-field
              type="number"
              v-model="form.copies"
              :error-messages="errors"
              label="Cópias"
            >
            </v-text-field>
          </ValidationProvider>
        </ValidationObserver>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="handleCancel" :disabled="loading"
          >Não</v-btn
        >
        <v-btn color="primary" text @click="handleAction" :loading="loading"
          >Sim</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "confirm-print-dialog",
  props: {
    value: Boolean,
    default_copies: Number,
    message: String
  },
  data() {
    return {
      loading: false,
      form: {
        copies: this.default_copies
      }
    };
  },
  methods: {
    async handleAction() {
      this.loading = true;
      await this.$listeners.action(this.form);
      this.loading = false;
      this.$emit("input", false);
    },
    handleCancel() {
      this.$emit("input", false);
    }
  }
};
</script>
